import React, { FC }                    from "react";
import { Button, Form, Icon, Popup }    from "semantic-ui-react";
import { ReservationSettingRepository } from "../../../../domain/reservation/ReservationSettingRepository";
import ReservationSpecialBusinessTime   from "../../../../domain/reservation/ReservationSpecialBusinessTime";

interface Props {
  repository: ReservationSettingRepository;
}

const ReservationSpecialTimeAddButton: FC<Props> = (props: Props) => {
  return (
    <>
      <Form>
        <Form.Field>
          <label>
            特別営業時間
            <Popup
              trigger={ <Icon name="help circle" style={ {marginLeft: "0.5rem"} }/> }
              size="mini"
            >
              特定の日にちで営業時間が変更される場合は、こちらで設定することができます。
            </Popup>
          </label>
          <Button
            onClick={ () => props.repository.addSpecialBusinessTime(new ReservationSpecialBusinessTime()) }
          >
            特別営業時間を追加する
          </Button>
        </Form.Field>
      </Form>
    </>
  );
};

export default ReservationSpecialTimeAddButton;